module.exports = __webpack_public_path__ + "img/avbi05a.7fbb72ef.png";